import { textToSpeechService } from './textToSpeechService';

const R2_BASE_PRIMARY = 'https://pub-3d7ad7f5d04d46a5b7232c0baf46d866.r2.dev';
const R2_BASE_BACKUP = 'https://pub-3d7ad7f5d04d46a5b7232c0baf46d866.r2.dev/biblioteca-backup';

const LANG_FOLDER_MAP: Record<string, string> = {
  en: 'english', ingles: 'english', 'en-us': 'english', 'en-gb': 'english',
  fr: 'french', frances: 'french', 'fr-fr': 'french',
  de: 'german', alemao: 'german', 'de-de': 'german',
  it: 'italian', italiano: 'italian', 'it-it': 'italian',
  pt: 'portuguese', portugues: 'portuguese', 'pt-br': 'portuguese',
  ru: 'russian', russo: 'russian', 'ru-ru': 'russian',
  es: 'spanish', espanhol: 'spanish', 'es-es': 'spanish',
  hu: 'hungarian', hungaro: 'hungarian', 'hu-hu': 'hungarian'
};

const LANG_CODE_MAP: Record<string, string> = {
  english: 'en', french: 'fr', german: 'de', italian: 'it',
  portuguese: 'pt', russian: 'ru', spanish: 'es', hungarian: 'hu',
  ingles: 'en', frances: 'fr', alemao: 'de', italiano: 'it',
  portugues: 'pt', russo: 'ru', espanhol: 'es', hungaro: 'hu'
};

export const getPronunciationAudioUrl = (
  languageOrFolder: string,
  level: string,
  cardId: number | string,
  langCode?: string
): string => {
  const cleanLang = (languageOrFolder || 'english').toLowerCase().trim();
  const folder = LANG_FOLDER_MAP[cleanLang] || cleanLang;
  const shortCode = langCode
    ? langCode.toLowerCase().split(/[-_]/)[0]
    : (LANG_CODE_MAP[folder] || 'en');
  const lvl = (level || 'A1').toUpperCase().trim();
  const cleanId = String(cardId).replace(/[^0-9]/g, '') || '1';

  return `${R2_BASE_PRIMARY}/pronunciation-lessons/${folder}/${lvl}/id-${cleanId}-${shortCode}.mp3`;
};

// In-Memory cache for ArrayBuffers of decoded MP3 files
const audioArrayBufferCache = new Map<string, ArrayBuffer>();

export const loadPronunciationArrayBuffer = async (audioUrl: string): Promise<ArrayBuffer | null> => {
  if (audioArrayBufferCache.has(audioUrl)) {
    return audioArrayBufferCache.get(audioUrl)!;
  }

  try {
    const response = await fetch(audioUrl, { mode: 'cors' });
    if (!response.ok) {
      if (audioUrl.includes('/pronunciation-lessons/') && !audioUrl.includes('/biblioteca-backup/')) {
        const backupUrl = audioUrl.replace(R2_BASE_PRIMARY, R2_BASE_BACKUP);
        const backupRes = await fetch(backupUrl, { mode: 'cors' });
        if (backupRes.ok) {
          const buf = await backupRes.arrayBuffer();
          audioArrayBufferCache.set(audioUrl, buf);
          return buf;
        }
      }
      return null;
    }

    const buf = await response.arrayBuffer();
    audioArrayBufferCache.set(audioUrl, buf);
    return buf;
  } catch (err) {
    console.warn('[PronunciationAudio] Error fetching audio from R2:', err);
    return null;
  }
};
